import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { PlaceholderPage } from '@/components/layout/PlaceholderPage';

export const Route = createFileRoute('/_app/reports')({
	component: ReportsRoute,
});

function ReportsRoute() {
	const { t } = useTranslation();
	return (
		<PlaceholderPage
			title={t('nav.reports')}
			description={t('placeholder.reports.description')}
			scope={t('placeholder.reports.scope')}
		/>
	);
}
